module.exports = require('./helpers/bundle-url').getBundleURL('iNcwZ') + "logo-dark.eefe0b7f.svg";